angular.module('SpidApp')

.controller('ShopController',
		['BASE_PUBLIC_URL', '$scope', '$state', '$rootScope', '$localStorage', '_', 'VacationService', 'Toaster', 'Cart', 'ConfigService',
function (BASE_PUBLIC_URL,   $scope,   $state,   $rootScope,   $localStorage,   _,   VacationService,   Toaster,   Cart,   ConfigService) {
	
	$scope.vacationOngoing = null
	
	$scope.cart = Cart.getInstance()

	VacationService.findByIdUser($localStorage.user.id, { isOnGoing: true }).then(function(vacations) {
		if (!vacations || vacations.length === 0) {
			
			var redirectToVacation = function () {
				Toaster.warning('Vous devez d\'abord ouvrir une vacation')
				$state.go('app.vacation')
			}
			
			return ConfigService.all().then(function (config) {
				return VacationService.findByAgencyId(config.agencyId)
			}).then(function (vacations) {
				vacations = _.filter(vacations, function (vacation) {
					return !vacation.endStateId
				})
				
				if (vacations.length === 0) {
					redirectToVacation()
				} else {
					$scope.currentVacation = vacations[0]
					$scope.vacationOngoing = moment($scope.currentVacation.dateStart).calendar()

					$scope.pageLoaded = true
				}
			}).catch(function () {
				redirectToVacation()
			})
		} else {
			$scope.currentVacation = vacations[0]
			$scope.vacationOngoing = moment($scope.currentVacation.dateStart).calendar()

			$scope.pageLoaded = true
		}
	})
}])
